import styled from 'styled-components'

export default styled.div`
	display: flex;
	flex-direction: column;
	max-width: 400px;
	margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/primitives/Container.js